import { Component, OnInit, forwardRef, Input, ViewChild } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { DemoozMessageComponent, DemoozModalComponent } from '@demooz/components';
import { NewsItemComponent, NewsQuestionComponent, QuestionsAnswerComponent } from '@app/components';
import { DataService, WidgetService } from '@app/services';
import { OperationNews, Question } from '@app/models';

class NewsElement {
    element: OperationNews|Question;
    type: 'news'|'question';
    constructor(element: OperationNews|Question, type: 'news'|'question'){
        this.element = element;
        this.type = type;
    }
}

@Component({
    selector: 'app-news-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozMessageComponent), forwardRef(() => DemoozModalComponent), 
        forwardRef(() => NewsItemComponent), forwardRef(() => NewsQuestionComponent), forwardRef(() => QuestionsAnswerComponent)
    ]
})
export class NewsListComponent  implements OnInit {
     
    @Input({alias : 'maxItems', required : false}) maxItems: number;

    @ViewChild('modalAnswer') modalAnswer: DemoozModalComponent;

    OperationNews = OperationNews;
    newsElements: Array<NewsElement> = [];
    showAll: boolean = false;
    questionToAnswer: Question|null = null;
    
    constructor(         
        public dataService: DataService,
        public widgetService: WidgetService
    ) { }

    ngOnInit() {
       this.initNewsElements();
    }
    
    initNewsElements(){
         let newsElements: Array<NewsElement> = [];
        
        this.dataService.operation.news.forEach(news => {
            newsElements.push(new NewsElement(news, 'news'));
        });
        
        if(this.dataService.widget.enableQuestionsCommunity){
            this.dataService.widget.questionsCommunity.forEach(question => {
                newsElements.push(new NewsElement(question, 'question'));
            });
        }
        
        newsElements.sort((a, b) => {
            let aOnTop = (a.element instanceof OperationNews ? a.element.onTop : false);
            let bOnTop = (b.element instanceof OperationNews ? b.element.onTop : false);
            let aDate = (a.element instanceof OperationNews ? (a.element.startDate ? moment(a.element.startDate, 'YYYY-MM-DD') : moment()) : moment(new Date(parseInt(a.element._.created))) ).format('YYYY-MM-DD');
            let bDate = (b.element instanceof OperationNews ? (b.element.startDate ? moment(b.element.startDate, 'YYYY-MM-DD') : moment()) : moment(new Date(parseInt(b.element._.created))) ).format('YYYY-MM-DD');
            let order = 0;
            if(aOnTop && !bOnTop){
                return -1;
            }
            else if(!aOnTop && bOnTop){
                return 1;
            }
            else if(aDate < bDate){
                order = 1;
            }
            else if (aDate > bDate){
                order = -1;
            }
            return order;
        });
        
        this.newsElements = newsElements;
    }

    getOperationNews(newsElements: NewsElement): OperationNews{
        return newsElements.element as OperationNews;
    }

    getQuestion(newsElements: NewsElement): Question{
        return newsElements.element as Question;
    }
       
    displayAll() {
        this.showAll = true;
    } 
    
    refreshNewsElements(status: boolean){
        if(status){
            this.initNewsElements();
        }
    }
    
    onAnswerQuestion(question: any){
        this.questionToAnswer = question;
        this.modalAnswer.open();
    }
    
    async onSendAnswerQuestion(status: boolean){
        if(status){
            await this.widgetService.refreshWidget();
            this.refreshNewsElements(true);
            this.modalAnswer.dismiss();
        }
    }
    
    onDidDismissModalAnswer($event: any){
        this.questionToAnswer = null;
    }
}
